import React from 'react';
import { Card, CardBody, CardHeader, CardFooter, Spinner } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

interface PCCardProps {
  id: string;
  children: React.ReactElement;
  footer?(): any;
  loading?: boolean;
}

/**
 * @author Jungwirth
 */
export const PCCard: React.FC<PCCardProps> = (props: Readonly<PCCardProps>): JSX.Element => {
  const { id, children, footer, loading } = props;

  const cardFooter = (
    <CardFooter>
      {footer ? footer(): ''}
    </CardFooter>
  );

  return (
    <Card className="mb-4">
      <CardHeader className="bg-primary text-light">
        <FormattedMessage id={id} />
      </CardHeader>
      <CardBody>
        {loading ? 
          <PCCardLoadingSpinner />
        : 
          children
        }
      </CardBody>
      {footer &&
        cardFooter}
    </Card>
  );
};


const PCCardLoadingSpinner = () => {
  return (
    <div className="d-flex justify-content-center py-5">
      <Spinner type="grow" color="primary" size="xl">Daten werden geladen</Spinner>
    </div>
  )
}
